'use client';

import { useEffect } from 'react';

/**
 * DES-107 — pin `data-theme="dark"` on `<body>` while the apex marketing
 * chrome is mounted.
 *
 * Same contract as the marketing-city lock (`app/(city)/CityDarkThemeBodyLock`,
 * WEB-612): the apex wrapper carries `data-theme="dark"`, but Radix portals
 * (the Wayfinder sheet, SearchSheet) mount under `document.body`, an
 * *ancestor* of that wrapper. Without this, a light-preferring visitor's
 * `<html data-theme="light">` leaves portalled overlays on light tokens over a
 * dark apex page. Restored on unmount so non-apex navigations keep the
 * visitor's preference.
 */
export function ApexDarkThemeBodyLock(): null {
  useEffect(() => {
    const { body } = document;
    const previous = body.getAttribute('data-theme');
    body.setAttribute('data-theme', 'dark');
    return () => {
      if (previous === null) {
        body.removeAttribute('data-theme');
      } else {
        body.setAttribute('data-theme', previous);
      }
    };
  }, []);

  return null;
}
